import { inject, Injector, runInInjectionContext } from '@angular/core'

import { firstValueFrom } from 'rxjs'

import { TranslateService } from '@ngx-translate/core'

import { AUTH_STORE } from '../tokens/auth-store.token'

/**
 * Initializes language settings using TranslateService in a safe DI context.
 * Should be called after bootstrapApplication.
 */
export async function initializeLanguage(injector: Injector, defaultLang = 'en') {
  await runInInjectionContext(injector, async () => {
    const translate = inject(TranslateService)
    const authStore = inject(AUTH_STORE)

    const userLang = authStore.getUserLanguage()
    const savedLang = localStorage.getItem('lang')
    const browserLang = navigator.language?.split('-')[0]
    const isBrowserLangDifferent = browserLang && browserLang !== defaultLang

    let langToUse = defaultLang

    if (userLang) {
      langToUse = userLang.split('-')[0]
    } else if (savedLang) {
      langToUse = savedLang.split('-')[0]
    } else if (isBrowserLangDifferent) {
      langToUse = browserLang
    }

    translate.setDefaultLang(defaultLang)
    await firstValueFrom(translate.use(langToUse))

    if (localStorage.getItem('lang') !== langToUse) {
      localStorage.setItem('lang', langToUse)
    }
  })
}
